import React from 'react';

const Block = ({ title, children }) => (children ? (
  <div>
    <p className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-amber-400">{title}</p>
    <div className="text-sm text-slate-200">{children}</div>
  </div>
) : null);

const Bullets = ({ items }) => (items?.length ? <ul className="list-disc space-y-0.5 pl-5">{items.map((x, i) => <li key={i}>{x}</li>)}</ul> : null);

export const GuideView = ({ g }) => {
  const exc = g.excepciones || {};
  return (
    <div data-testid="procedural-guide" className="space-y-4 rounded-xl border border-amber-500/30 bg-slate-900 p-4">
      <div>
        <p className="text-[11px] uppercase tracking-wider text-amber-400">Procedimiento aplicable</p>
        <p data-testid="guide-procedimiento" className="font-semibold text-white">{g.procedimiento}</p>
        <p className="mt-1 text-xs text-slate-400">{g.fundamento}</p>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        <Block title="Cuantía">{g.cuantia}</Block>
        <Block title="Tribunal competente">{g.tribunal_competente}</Block>
      </div>
      {g.etapas?.length > 0 && (
        <Block title="Etapas">
          <ol className="space-y-2">
            {g.etapas.map((e, i) => (
              <li key={i} className="rounded-lg bg-slate-800/60 p-2">
                <p className="font-medium text-white">{i + 1}. {e.etapa} <span className="text-xs text-amber-300">· {e.plazo}</span></p>
                <p className="text-xs text-slate-300">{e.descripcion} <span className="text-slate-500">({e.norma})</span></p>
              </li>
            ))}
          </ol>
        </Block>
      )}
      <div className="grid gap-3 md:grid-cols-2">
        <Block title="Medidas prejudiciales">{g.medidas_prejudiciales}</Block>
        <Block title="Medidas precautorias">{g.medidas_precautorias}</Block>
      </div>
      <Block title="Excepciones">
        <p className="text-xs text-slate-400">Dilatorias</p><Bullets items={exc.dilatorias} />
        <p className="mt-1 text-xs text-slate-400">Perentorias</p><Bullets items={exc.perentorias} />
        <p className="mt-1 text-xs text-slate-300">{exc.oportunidad}</p>
      </Block>
      <Block title="Oposiciones e incidentes">{g.oposiciones}</Block>
      <Block title="Réplica y dúplica">{g.replica_duplica}</Block>
      <Block title="Prueba">{g.prueba}</Block>
      {g.resoluciones?.length > 0 && (
        <Block title="Resoluciones judiciales">
          <div className="space-y-1">{g.resoluciones.map((r, i) => <p key={i}><span className="font-medium text-white">{r.tipo}:</span> {r.que_es} <span className="text-slate-400">Ej.: {r.ejemplo_en_este_juicio}. Recursos: {r.recursos}</span></p>)}</div>
        </Block>
      )}
      {g.recursos?.length > 0 && (
        <Block title="Recursos">
          <div className="space-y-1">{g.recursos.map((r, i) => <p key={i}><span className="font-medium text-white">{r.recurso}</span> — contra {r.procede_contra}; plazo {r.plazo}; ante {r.tribunal}; {r.efectos} <span className="text-slate-500">({r.norma})</span></p>)}</div>
        </Block>
      )}
      <Block title="Plazos clave"><Bullets items={g.plazos_clave} /></Block>
      {(g.recomendaciones_cerebro?.length > 0 || g.riesgos_procesales?.length > 0) && (
        <div data-testid="guide-cerebro" className="space-y-2 rounded-lg border border-purple-500/40 bg-purple-500/10 p-3">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-purple-300">Recomendaciones de Cerebro para este caso</p>
          <ul className="space-y-1 text-sm text-slate-200">
            {(g.recomendaciones_cerebro || []).map((r, i) => <li key={i}><span className="font-medium text-white">{r.etapa}:</span> {r.recomendacion}</li>)}
          </ul>
          {g.riesgos_procesales?.length > 0 && (
            <div><p className="text-xs text-orange-300">Riesgos procesales</p><div className="text-sm text-slate-200"><Bullets items={g.riesgos_procesales} /></div></div>
          )}
        </div>
      )}
      <Block title="La audiencia que se simulará">{g.audiencia_actual}</Block>
      {g.vigencia && <p className="text-[11px] text-slate-500">{g.vigencia}</p>}
    </div>
  );
};
